// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"b557764a3b9531388ba5","655":"067147cc91a1aa06e078"}[chunkId] + ".js";
};